import { render, staticRenderFns } from "./user-phone-settings-page.vue?vue&type=template&id=7e337925&scoped=true"
import script from "./user-phone-settings-page.vue?vue&type=script&lang=js"
export * from "./user-phone-settings-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e337925",
  null
  
)

export default component.exports